import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, MessageCircle, Linkedin, Instagram, Clock } from 'lucide-react';
import { company, contact, categories } from '../mock/mock';
import { waDisplay, openWhatsApp } from '../lib/wa';

const Footer = () => {
  return (
    <footer className="bg-ktc-greenDark text-ktc-ivory/80">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="mb-5">
              <div className="inline-block bg-ktc-ivory rounded-lg px-4 py-3">
                <img src={company.logo} alt="Kassam Trading Company" className="h-16 w-auto object-contain" />
              </div>
            </div>
            <p className="text-sm leading-relaxed text-ktc-ivory/70">
              Pakistan's REAP-registered rice miller and exporter since 1999. Premium rice, Himalayan Pink Salt, wheat, corn and sesame. FOB Port Qasim, CIF worldwide.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {[
                { Icon: Linkedin, href: 'https://www.linkedin.com/company/kassamtradingcompany', label: 'LinkedIn' },
                { Icon: Instagram, href: 'https://www.instagram.com/ktc.tradingg', label: 'Instagram' },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Kassam Trading Company on ${label}`}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="h-9 w-9 grid place-items-center rounded-full border border-ktc-ivory/20 hover:bg-ktc-gold hover:border-ktc-gold transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-ktc-ivory font-sans font-semibold text-sm uppercase tracking-wider mb-5">Products</h4>
            <ul className="space-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link to={`/products?category=${c.id}`} className="hover:text-ktc-goldLight transition-colors">{c.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-ktc-ivory font-sans font-semibold text-sm uppercase tracking-wider mb-5">Company</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="hover:text-ktc-goldLight transition-colors">About KTC</Link></li>
              <li><Link to="/rice-exporters-pakistan" className="hover:text-ktc-goldLight transition-colors">Rice Exporters in Pakistan</Link></li>
              <li><Link to="/insights" className="hover:text-ktc-goldLight transition-colors">Insights & Guides</Link></li>
              <li><Link to="/global-reach" className="hover:text-ktc-goldLight transition-colors">Global Reach</Link></li>
              <li><Link to="/certificates" className="hover:text-ktc-goldLight transition-colors">Certificates</Link></li>
              <li><Link to="/gallery" className="hover:text-ktc-goldLight transition-colors">Gallery</Link></li>
              <li><Link to="/updates" className="hover:text-ktc-goldLight transition-colors">Updates</Link></li>
              <li><Link to="/catalogs" className="hover:text-ktc-goldLight transition-colors">Catalogs & Brochures</Link></li>
              <li><Link to="/quote" className="hover:text-ktc-goldLight transition-colors">Request a Quote</Link></li>
              <li><Link to="/contact" className="hover:text-ktc-goldLight transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-ktc-ivory font-sans font-semibold text-sm uppercase tracking-wider mb-5">Get in Touch</h4>
            <ul className="space-y-3.5 text-sm">
              <li className="flex gap-3"><MapPin size={17} className="text-ktc-gold shrink-0 mt-0.5" /><span>{contact.headOffice}</span></li>
              <li className="flex gap-3"><Phone size={17} className="text-ktc-gold shrink-0 mt-0.5" /><a href={`tel:${contact.phoneRaw}`} className="hover:text-ktc-goldLight">{contact.phone}</a></li>
              <li className="flex gap-3"><MessageCircle size={17} className="text-ktc-gold shrink-0 mt-0.5" /><button type="button" onClick={() => openWhatsApp()} data-testid="footer-whatsapp-button" className="hover:text-ktc-goldLight">{waDisplay()}</button></li>
              <li className="flex gap-3"><Mail size={17} className="text-ktc-gold shrink-0 mt-0.5" /><a href={`mailto:${contact.email}`} className="hover:text-ktc-goldLight">{contact.email}</a></li>
              <li className="flex gap-3"><Clock size={17} className="text-ktc-gold shrink-0 mt-0.5" /><span>{contact.hours}</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-ktc-ivory/15 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-ktc-ivory/60">
          <p>© {new Date().getFullYear()} Kassam Trading Company. All rights reserved.</p>
          <p>REAP {company.reapId} · ISO · HACCP · Halal Certified</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
